import {message,Col, Input, Layout, Row, Tooltip, Upload, Button, InputNumber } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { Content } from 'antd/lib/layout/layout';
import { RouteComponentProps } from 'react-router';
import * as constants from '../../../constants/constants';
import { sendHttpPostRequest } from '../../../api/http-request';

import React, {useEffect, useRef, useState} from "react";

interface  Props extends  RouteComponentProps<{ project_id: string }> {
    project_id: string
}

import myStyles from "./oam-project.module.less";
import {PlusOutlined} from '@ant-design/icons';  

import OAMSider from '../oam-sider';
import Cookies from 'js-cookie';



/** 项目编辑页 */
export const OAMProjectCreate: React.FC<Props> = (props) => {
    const project_id = props.location.search.split("=")[1]
    
    const [coverFileList, setCoverfileList] = useState([])

    const [name, setName] = useState("");//项目名称
    //const [description, setDescription] = useState("");//项目介绍
    const [cover, setCover] = useState("");//项目封面图
    const [projectAim,setProjectAim] = useState("");//实训目标
    const [trainingSkills, setTrainingSkills] = useState("");//锻炼能力
    const [tools, setTools] = useState("");//实践工具
    const [teachingHours, setTeachingHours] = useState(0);//实训教学课时
    const [learningHours, setLearningHours] = useState(0);//个人实训课时
    const [precondition, setPrecondition]  = useState("");//前置基础

    const [exercistList, setExerciseList] =  useState([] as any);//知识检测习题列表

    const [introduction,setIntroduction] = useState("");//项目介绍
    const [projectSteps,setProjectSteps] = useState( null as any);//项目流程

    const [projectMenu, setProjectMenu] = useState( null as any);//项目大纲


    useEffect(() => {
      //queryProject();
  }, [])


    // 上传案例封面
    const onCoverChange = (info: any) => {
        setCoverfileList(info.fileList)
        const { status } = info.file
        if (status !== 'uploading') {
          //上传中
          console.log(info.file, info.fileList)
        }
        if (status === 'done') {
          //上传成功
          let new_cover = info.file.response.img_url
          let code = info.file.response.code
          code == -100 ? ()=>{} : document.getElementById("video-cover")?.setAttribute("src", new_cover)
          setCover(constants.BACKEND_URL + info.file.response.image_url )
        } else if (status === 'error') {
          //上传失败
          message.error(`${info.file.name} file upload failed.`)
        }
      }
    
      // 校验图片类型和大小
      function beforeCoverUpload(file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
          message.error('请上传png或jpg格式的图片!');
        }
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
          message.error('请上传小于5M的图片');
        }
        return isJpgOrPng && isLt5M;
      }
    
      // 上传cover传参
      const uploadCoverData = {
        sessionid: Cookies.get("sessionid"),
        sid: Cookies.get("sessionid"),
        project_id: project_id,
      }
    
      const uploadCoverButton = (
        <div>
          {<PlusOutlined />}
          <div style={{ marginTop: 8 }}>Upload</div>
        </div>
      );

    /**
     * 更新项目
     */
     const updateProject = () => {
      sendHttpPostRequest(
          'course/api/oam_update_project',
          {
              sessionid: Cookies.get("sessionid"),
              project_id: project_id,
              name: name,
              projectAim: projectAim,
              tools: tools,
              teachingHours: teachingHours,
              learningHours: learningHours,
              precondition: precondition,
              exercistList: exercistList,
              introduction: introduction,
              projectSteps: projectSteps,
              projectMenu: projectMenu,
              cover: cover,
              ability: trainingSkills,
              //description: description,
          },
          updateProjectCallback
      )
  }

  /**
   * 更新项目回调
   * @param response
   */
  const updateProjectCallback = (response: any) => {
      // console.log(response)
      message.destroy();
      if (response.code == -100) {
          // 未登录
          window.location.href = '/oam_login?next=oam_chapter';
      } else if (response.is_ok == true) {
          // 成功
          //setChapterId(response.chapter_id);
          message.success("项目" + response.project_id + "保存成功~")
         
      } /*else if (response.code == -501) {
          // 权限不足
          window.location.href = '/oam_login?next=oam_chapter';
      } */else {
          message.error(response.message);
      }
  }
 
   /**
     * 查询项目
     */
    const queryProject = () => {
      sendHttpPostRequest(
          'course/api/oam_query_project_by_id',
          {
              sessionid: Cookies.get("sessionid"),
              project_id: project_id,
          },
          queryProjectCallback
      )
  }

  /**
   * 查询项目回调
   * @param response
   */
  const queryProjectCallback = (response: any) => {
      // console.log(response)
      message.destroy();
      if (response.code == -100) {
          // 未登录
          window.location.href = '/oam_login?next=oam_project';
      } else if (response.is_ok == true) {
          // 成功
          setName(response.query_info?.name)
          //setDescription(response.query_info?.description)
          //message.success(response.chapter_id)
         
      } /*else if (response.code == -501) {
          // 权限不足
          window.location.href = '/oam_login?next=oam_chapter';
      } */else {
          message.error(response.message);
      }
  }
 


    return (
        <Layout style={{ minHeight: '100vh' }}>
        <OAMSider keys={"2"} openKeys={["sub-project"]} ></OAMSider>
        <div>
            <Content style={{ minHeight: '90vh',backgroundColor:'#fff',borderRadius:5,width:800,margin:30 ,paddingTop:20}}>
            <div style={{paddingLeft:50,paddingRight:50,paddingBottom:50}}>

            <Row gutter={[8,8]} justify='end'  align='middle' style={{marginBottom:20}} >
                    <Col  span={24} style={{color:"#00000073",textAlign:'right'}}>
                    <Button onClick={()=>{}} style={{borderRadius:20,width:80,marginRight:10}} type="primary"> 预 览 </Button>
                      
                        <Button onClick={()=>{updateProject()}} style={{borderRadius:20,width:80}} type="primary">保 存</Button>
                        </Col>       
                </Row>

                <Row gutter={[8,8]} justify='start'  align='middle' style={{marginBottom:20}} >
                    <Col flex="80px" style={{color:"#00000073",textAlign:'left'}}>项目名称</Col>
                    <Col flex="auto" style={{textAlign:'left'}}>
                        <Input placeholder="请输入项目名称" 
                        required={true} 
                        value = {name} 
                        onChange={(e)=>{setName(e.target.value)}} 
                        style={{borderRadius:3,width:"100%"}}/>
                    </Col>
                </Row>


                {/*<Row gutter={[8,8]} justify='start'  align='middle' style={{marginBottom:20}} >
                    <Col flex="80px" style={{color:"#00000073",textAlign:'left'}}>项目封面</Col>
                    <Col flex="auto" style={{textAlign:'left'}}>
                    <div className={myStyles.uploadCover}>
                          <Upload
                            beforeUpload={beforeCoverUpload}
                            accept={'image/*'}
                            action={constants.BACKEND_API_URL + 'video/api/upload_cover/'}
                            listType="picture-card"
                            name="video_cover"
                            fileList={coverFileList}
                            onChange={onCoverChange}
                            data={uploadCoverData}
                            showUploadList={false}
                            
                        >
                        { cover ?
                            <img
                            id="video-cover"
                            style={{width:"250px",height:"130px"}}
                            src={cover}
                            /> : uploadCoverButton

                        }
                            
                        </Upload>
                        </div>
                    </Col>
                    </Row>*/}

                <Row gutter={[8,8]} justify='start'  align='middle' style={{marginBottom:20}} >
                    <Col flex="80px" style={{color:"#00000073",textAlign:'left'}}>项目封面</Col>
                    <Col flex="auto" style={{textAlign:'left'}}>
                        <Input placeholder="请输入项目封面地址" 
                        required={true} 
                        value = {cover} 
                        onChange={(e)=>{setCover(e.target.value)}} 
                        style={{borderRadius:3,width:"100%"}}/>
                    </Col>
                </Row>


                <Row gutter={[8,8]} justify='start'  align='top' style={{marginBottom:20}} >
                    <Col flex="80px" style={{color:"#00000073",textAlign:'left'}}>实训目标</Col>
                    <Col flex="auto" style={{textAlign:'left'}}>
                        <TextArea placeholder="请输入实训目标" 
                        style = {{borderRadius:3,width:"100%"}} 
                        autoSize = {{minRows: 3}}  
                        value = {projectAim} 
                        onChange={(e)=>{setProjectAim(e.target.value)}} 
                        />

                    </Col>
                </Row>

                <Row gutter={[8,8]} justify='start'  align='top' style={{marginBottom:20}} >
                    <Col flex="80px" style={{color:"#00000073",textAlign:'left'}}>锻炼能力</Col>
                    <Col flex="auto" style={{textAlign:'left'}}>
                        <TextArea placeholder="请输入锻炼能力，多个用英文分号‘;’隔开，例如 数据可视化;数据采集;分类模型" 
                        style = {{borderRadius:3,width:"100%"}} 
                        autoSize = {{minRows: 3}} 
                        value = {trainingSkills} 
                        onChange={(e)=>{setTrainingSkills(e.target.value)}} 
                        />

                    </Col>
                </Row>

                <Row gutter={[8,8]} justify='start'  align='top' style={{marginBottom:20}} >
                    <Col flex="80px" style={{color:"#00000073",textAlign:'left'}}>实践工具</Col>
                    <Col flex="auto" style={{textAlign:'left'}}>
                        <TextArea placeholder="请输入实践工具" 
                        style = {{borderRadius:3,width:"100%"}} 
                        autoSize = {{minRows: 3}} 
                        value = {tools} 
                        onChange={(e)=>{setTools(e.target.value)}} 
                        />

                    </Col>
                </Row>

                <Row gutter={[8,8]} justify='start'  align='middle' style={{marginBottom:20}} >
                    <Col flex="80px" style={{color:"#00000073",textAlign:'left'}}>教学课时</Col>
                    <Col flex="auto" style={{textAlign:'left'}}>
                    <InputNumber placeholder="请输入教学课时" 
                        required={true} 
                        value = {teachingHours} 
                        onChange={(newValue)=>{setTeachingHours(newValue)}} 
                        style={{maxWidth:200,borderRadius:3,width:"100%"}}/>

                    </Col>
                </Row>

                <Row gutter={[8,8]} justify='start'  align='middle' style={{marginBottom:20}} >
                    <Col flex="80px" style={{color:"#00000073",textAlign:'left'}}>实训课时</Col>
                    <Col flex="auto" style={{textAlign:'left'}}>
                    <InputNumber placeholder="请输入个人实训课时" 
                        required={true} 
                        value = {learningHours} 
                        onChange={(newValue)=>{setLearningHours(newValue)}} 
                        style={{maxWidth:200,borderRadius:3,width:"100%"}}/>

                    </Col>
                </Row>

                <Row gutter={[8,8]} justify='start'  align='top' style={{marginBottom:20}} >
                    <Col flex="80px" style={{color:"#00000073",textAlign:'left'}}>前置基础</Col>
                    <Col flex="auto" style={{textAlign:'left'}}>
                        <TextArea placeholder="请输入前置基础" 
                        style = {{borderRadius:3,width:"100%"}} 
                        autoSize = {{minRows: 3}} 
                        value = {precondition} 
                        onChange={(e)=>{setPrecondition(e.target.value)}} 
                        />

                    </Col>
                </Row>


                <Row gutter={[8,8]} justify='start'  align='middle' style={{marginBottom:20}} >
                    <Col flex="80px" style={{color:"#00000073",textAlign:'left'}}>检测习题</Col>
                    <Col flex="auto" style={{textAlign:'left'}}>
                        <TextArea placeholder="请输入检测习题列表,示例：[3,56,98]" 
                        style = {{borderRadius:3,width:"100%"}} 
                        autoSize = {{minRows: 3, maxRows: 6}} 
                        value = {exercistList} 
                        onChange={(e)=>{setExerciseList(e.target.value)}} 
                        />

                    </Col>
                </Row>


                <Row gutter={[8,8]} justify='start'  align='top' style={{marginBottom:20}} >
                    <Col flex="80px" style={{color:"#00000073",textAlign:'left'}}>项目介绍</Col>
                    <Col flex="auto" style={{textAlign:'left'}}>
                        <TextArea placeholder="请输入项目介绍" 
                        style = {{borderRadius:3,width:"100%"}} 
                        autoSize = {{minRows: 3}} 
                        value = {introduction} 
                        onChange={(e)=>{setIntroduction(e.target.value)}} 
                        />

                    </Col>
                </Row>


                <Row gutter={[8,8]} justify='start'  align='top' style={{marginBottom:20}} >
                    <Col flex="80px" style={{color:"#00000073",textAlign:'left'}}>项目流程</Col>
                    <Col flex="auto" style={{textAlign:'left'}}>
                        <TextArea placeholder='请输入项目流程，示例：[{step:"数据采集","subSteps":["爬取","抽取","存储"],...}]'
                        style = {{borderRadius:3,width:"100%"}} 
                        autoSize = {{minRows: 3}} 
                        value = {projectSteps} 
                        onChange={(e)=>{setProjectSteps(e.target.value)}} 
                        />

                    </Col>
                </Row>

                <Row gutter={[8,8]} justify='start'  align='middle' style={{marginBottom:20}} >
                    <Col flex="80px" style={{color:"#00000073",textAlign:'left'}}>项目大纲</Col>
                    <Col flex="auto" style={{textAlign:'left'}}>
                        <InputNumber placeholder="请输入大纲ID" 
                            required={true} 
                            value = {projectMenu} 
                            onChange={(newValue)=>{setProjectMenu(newValue)}} 
                            style={{maxWidth:200,borderRadius:3,width:"100%"}}/>

                    </Col>
                </Row>



            </div>
  
            </Content>
        </div>
    </Layout>
    )

}

export default OAMProjectCreate

